import { c as _c } from "react/compiler-runtime";
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FooterSwiper } from './FooterSwiper.client';
function FooterNotice() {
  const $ = _c(4);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="flex h-full items-center "><h2 className="w-[81px] font-medium text-colorFg01 text-sm leading-none">{"\uACF5\uC9C0\uC0AC\uD56D"}</h2></div>;
    t1 = <FooterSwiper />;
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <button type="button" className="btn_prev flex h-[14px] items-center"><FontAwesomeIcon className="h-[11px] w-[11px]" icon={faChevronUp} /></button>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <section><div className="relative flex h-10 w-full justify-center overflow-hidden border-borderBg01 border-t border-b px-7.5 text-left"><div className="flex w-full max-w-[1280px]">{t0}{t1}<div className="flex h-full items-center gap-3">{t2}<button type="button" className="btn_next mt-1 flex h-[14px] items-center"><FontAwesomeIcon className="mb-1 h-[11px] w-[11px]" icon={faChevronDown} /></button></div></div></div></section>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
}
export default FooterNotice;